import { z } from 'zod';

export const FlowMemorySchema = z.object({
  id: z.string(),
  flowId: z.string(),
  runId: z.string(),
  scope: z.string().nullable().optional(),
  content: z.string(),
  metadata: z.record(z.string(), z.unknown()).nullable().optional(),
  importance: z.number().min(0).max(1).default(0.5),
  createdAt: z.number(),
});
export type FlowMemory = z.infer<typeof FlowMemorySchema>;

export const FlowMemoryQuerySchema = z.object({
  flowId: z.string(),
  query: z.string(),
  scope: z.string().optional(),
  limit: z.number().int().positive().optional().default(10),
});
export type FlowMemoryQuery = z.infer<typeof FlowMemoryQuerySchema>;

export const FlowMemoryResultSchema = z.object({
  memory: FlowMemorySchema,
  score: z.number(),
});
export type FlowMemoryResult = z.infer<typeof FlowMemoryResultSchema>;
